import data from '../public/locales/en-GB/common.json'

export type LocaleKey = keyof typeof data

export const defaultCreateButtonKey: LocaleKey = 'productpage_photobooks_create_button'
